import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: ${({ theme }) => theme.palette.grey[50]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
`;
